/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import loadingConfig from '../config/loading.config.json';
import usersImportConfig from '../config/usersImport.config.json';

import { DEFAULT_APP_CONFIG } from '@/config/default.config';

import { templateReplacer } from '@/helpers/template.replace';

export interface IStaticPageContentMethods extends IPluginMethodMap {
  getStaticPageContentSync(args: any): any;
}

export class StaticPageContentService implements IAgentPlugin {
  readonly methods: IStaticPageContentMethods;

  constructor() {
    this.methods = {
      getStaticPageContentSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    return {
      loading: this.getTransformConfig(loadingConfig),
      userListImport: this.getTransformConfig(usersImportConfig),
    };
  }

  private getTransformConfig(data: any) {
    const _transConfig = templateReplacer(JSON.stringify(data), {
      holder_name: DEFAULT_APP_CONFIG?.platformSemantics?.semantics?.holder,
      holders_name: DEFAULT_APP_CONFIG?.platformSemantics?.semantics?.holders,
      holder_group: DEFAULT_APP_CONFIG?.platformSemantics?.HoldersGroups?.title,
    });
    return JSON.parse(_transConfig);
  }
}
